// extracted by mini-css-extract-plugin
export var chatHtmlText = "_q5-2";
export var chatLink = "_q5-0";
export var chatText = "_q5-1";